module.exports = __webpack_public_path__ + "img/autumnclouds.e44135e5.jpg";